<template lang="pug">
.h-screen.flex.items-center.justify-center
    .max-w-2xl
        h1.text-red-500.font-bold.text-6xl {{ error.statusCode }}
        p.text-3xl {{ error.message }}
        span {{ error.url }}
        .mt-10
        button(@click="handleError").btn-primary Go Back Home
</template>

<script setup>
const props = defineProps({
	error: Object,
})

const handleError = () => clearError({ redirect: "/" })
</script>
